import { newLayout } from '../theme';

/**
 * Lab `LoadingButton` extends `Button` but adds its own `MuiLoadingButton`
 * theme key with a separate `.MuiLoadingButton-root` class. Without this
 * override, the lab class wins source-order vs. `.MuiButton-root` for any
 * shared property — so the global `MuiButton` font-size override wouldn't
 * propagate to raw `LoadingButton` usages.
 *
 * Pinning `fontSize` here keeps every raw `LoadingButton` aligned with the
 * 14px (`body2`) convention used by every wrapped Button (Primary,
 * Secondary, Tertiary).
 */
export default {
  styleOverrides: {
    root: {
      fontSize: newLayout.fontSize.body2,
    },
  },
};
